import { useState } from "react";
import Navbar from "../components/layout/Navbar";
import scaun from "../assets/scaun.jpg";
import cabinet from "../assets/cabinet.avif";

export default function HomePage() {
  const [showMore, setShowMore] = useState(false);
  const [activeFaq, setActiveFaq] = useState(null);
  const [showFaq, setShowFaq] = useState(false);

  const faqItems = [
    {
      question: "CE PRESUPUNE SPECIALIZAREA ÎN ENDODONȚIE?",
      answer: [
        "După finalizarea ciclului de licență în stomatologie, care presupune 6 ani de studiu, medicii care aleg să se specializeze în endodonție urmează un rezidențiat de 3 ani într-un spital clinic."
      ],
    },
    {
      question: "CÂT TIMP DUREAZĂ UN TRATAMENT DE CANAL?",
      answer: [
        "Durata unui tratament de canal poate varia între o oră și trei ore, în funcție de complexitatea cazului.",
        "Totuși, pentru confortul pacientului, o ședință nu depășește, de regulă, 90 de minute. Dacă tratamentul necesită mai mult timp, acesta va fi împărțit în două ședințe, programate în zile diferite."
      ],
    },
    {
      question: "CE ESTE RETRATAMENTUL ENDODONTIC ȘI CÂND SE RECOMANDĂ?",
      answer: [
        "Uneori, este necesară reintervenția asupra unui dinte deja tratat endodontic, pentru a corecta anumite erori apărute în timpul tratamentului anterior. Cele mai frecvente situații includ: îndepărtarea incompletă a pulpei dentare, care poate duce la infecție, sau sigilarea inadecvată a canalelor radiculare, care permite contaminarea cu bacterii."
      ],
    },
    {
      question: "CARE SUNT PROCEDURILE PAS CU PAS CUPRINSE ÎNTR-UN TRATAMENT DE CANAL?",
      answer: [
        "Înainte de începerea tratamentului, se va administra anestezie locală, de regulă pe bază de articaină, care asigură analgezie pentru aproximativ 90 de minute. Ulterior, dintele care urmează să fie tratat va fi izolat de restul cavității orale cu ajutorul unei folii de cauciuc (diga), ce creează un câmp aseptic în jurul dintelui.",
        "Pentru a accesa spațiul endodontic (interiorul dintelui, unde se află pulpa dentară), medicul va folosi freze rotative pentru a perfora straturile de smalț și dentină sau pentru a îndepărta eventualele materiale de restaurare coronară (plombe sau coroane) și zonele cariate de pe suprafața dintelui.",
        "După accesare, spațiul endodontic este lărgit mecanic și dezinfectat chimic. La final, acesta este umplut cu materiale biocompatibile care asigură o sigilare etanșă, prevenind reinfectarea."
      ],
    },
    {
      question: "CE URMEAZĂ DUPĂ TRATAMENTUL DE CANAL?",
      answer: [
        "La finalul tratamentului, pacientul va părăsi cabinetul de endodonție cu o restaurare provizorie realizată din materiale compozite, care sigilează interiorul dintelui. Uneori, pentru ancorarea restaurării compozite pe dintele tratat endodontic, este necesar un pivot din fibră de sticlă, cimentat în aceeași ședință în care se realizează și tratamentul de canal.",
        "Ulterior, pacientului i se va recomanda, dacă este cazul, să se adreseze unui medic stomatolog generalist pentru restaurarea finală, care poate consta într-o coroană de acoperire totală sau parțială."
      ],
    },
    {
      question: "POT APĂREA SIMPTOME DUREROASE DUPĂ TRATAMENTUL DE CANAL?",
      answer: [
        "Da, durerea post-operatorie poate apărea, însă este de obicei de intensitate mică sau moderată. Atunci când apare, poate fi ameliorată cu ibuprofen (400 mg la 6 ore) și paracetamol (500 mg la 8 ore).",
        "De regulă, disconfortul dispare în primele 72 de ore, însă uneori poate persista până la 10 zile. În cazuri rare, zona de gingie aferentă dintelui poate deveni umflată și înroșită, semn al unui proces inflamator acut. Nu este motiv de panică, însă în acest caz este necesar să reveniți în cabinet pentru examinare și, dacă este cazul, vi se vor prescrie antibiotice."
      ],
    },
    {
      question: "POT FACE TRATAMENT DE CANAL DACĂ SUNT ÎNSĂRCINATĂ?",
      answer: [
        "Femeile însărcinate în primul și al treilea trimestru nu pot beneficia de tratamente endodontice cu anestezie. Totuși, unele proceduri nedureroase, fără anestezie și care nu necesită un timp îndelungat, pot fi realizate cu caracter provizoriu.",
        "În trimestrul al doilea de sarcină, tratamentele endodontice cu anestezie și durată scurtă pot fi efectuate în siguranță."
      ],
    },
    {
      question: "POT FACE TRATAMENT DE CANAL DACĂ ALĂPTEZ?",
      answer: [
        "Da, tratamentul de canal este sigur în perioada alăptării. Anestezia utilizată în mod obișnuit nu afectează alăptarea și nu prezintă riscuri pentru copil. Totuși, este important să informați medicul despre această perioadă pentru a adapta tratamentul corespunzător."
      ],
    },
  ];

  const toggleFaq = (index) => {
    setActiveFaq((prev) => (prev === index ? null : index));
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 flex flex-col pt-20">
      {/* Navbar sticky transparent */}
      <Navbar />

      {/* Hero Section */}
      <section className="bg-blue-100 text-blue-900 py-14 sm:py-16 px-4 sm:px-8 text-center">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
          Clinica Endodontică Microscop
        </h1>
        <p className="text-base sm:text-lg lg:text-xl max-w-3xl mx-auto leading-relaxed">
          Expertiză în tratamente endodontice de precizie cu ajutorul microscopului dentar.
        </p>
      </section>

      {/* Informational Section */}
      <section className="bg-white py-14 sm:py-16 px-4 sm:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto bg-blue-50/60 rounded-3xl shadow-inner px-6 sm:px-10 py-10 space-y-4">
          <h2 className="text-2xl sm:text-3xl font-semibold text-blue-900">
            Ce este endodonția și care sunt avantajele tratamentelor endodontice realizate la microscop?
          </h2>
          <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
            Endodonția este o supraspecializare a stomatologiei care se ocupă cu diagnosticarea, prevenirea și tratarea afecțiunilor pulpare – țesutul din interiorul dintelui, care conține nervi și vase de sânge.
          </p>
          {!showMore ? (
            <div className="flex justify-end mt-6">
              <button
                onClick={() => setShowMore(true)}
                className="bg-blue-700 hover:bg-blue-800 text-white font-semibold text-sm sm:text-base inline-flex items-center gap-2 px-5 py-2 rounded-full shadow transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-300"
                type="button"
              >
                Mai multe informatii
                <span aria-hidden>{">"}</span>
              </button>
            </div>
          ) : (
            <>
              <div className="space-y-4 text-gray-700 text-sm sm:text-base leading-relaxed">
                <p>
                  Structura unui dinte poate fi înțeleasă ușor prin comparație cu păpușile rusești "matryoshka" – este alcătuit din două straturi concentrice de țesut dur și un „miez moale”, care păstrează forma dintelui, dar la o scară mai mică.
                </p>
                <p>
                  La exterior, smalțul dentar formează o barieră protectoare pentru dentină, un țesut semipermeabil. În interior, se află pulpa dentară, un țesut moale, bogat în nervi și vase de sânge, sensibil la diverși stimuli (în special la rece).
                </p>
                <p>
                  Când straturile exterioare nu mai oferă o protecție adecvată, pulpa dentară devine expusă și poate reacționa dureros. Dacă această inflamație se agravează și durerea devine constantă, țesutul pulpar trebuie îndepărtat complet și înlocuit cu un material biocompatibil.
                </p>
                <p>
                  Pulpa dentară are un volum de aproximativ 0,05 ml, fiind dispusă central în dinte, și se continuă spre vârful rădăcinilor prin canalele radiculare. Acestea pot avea un lumen extrem de îngust – de doar 0,1 mm, comparabil cu grosimea unui fir de păr.
                </p>
                <p>
                  Avantajul microscopului operator dentar, care oferă o mărire de până la 10x, constă tocmai în posibilitatea de a localiza și îndepărta cu precizie acest țesut fin din interiorul dintelui – țesut care, altfel, ar putea trece neobservat cu ochiul liber, punând în pericol succesul tratamentului.
                </p>
              </div>
              <div className="flex justify-end mt-6">
                <button
                  onClick={() => setShowMore(false)}
                  className="bg-blue-700 hover:bg-blue-800 text-white font-semibold text-sm sm:text-base inline-flex items-center gap-2 px-5 py-2 rounded-full shadow transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-300"
                  type="button"
                >
                  mai puțin
                  <span aria-hidden>{"<"}</span>
                </button>
              </div>
            </>
          )}
        </div>
      </section>

      {/* Servicii - 3 carduri */}
      <section className="bg-white py-14 sm:py-16 px-4 sm:px-6 lg:px-10 flex-1">
        <h2 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8 text-center">Serviciile Noastre</h2>
        <div className="card-grid max-w-6xl mx-auto">
          {/* Card 1 */}
          <div className="bg-blue-50 rounded-2xl shadow hover:shadow-lg transition flex flex-col">
            <img
              src={scaun}
              alt="Tratament de canal"
              className="rounded-t-2xl h-40 sm:h-48 w-full object-cover"
            />
            <div className="p-6 flex flex-col flex-1">
              <h3 className="font-semibold text-lg sm:text-xl mb-2">Consultatie initiala </h3>
              <p className="text-blue-700 font-bold mb-2 text-sm sm:text-base">de la 400 RON</p>
              <p className="text-gray-600 text-sm sm:text-base flex-1 leading-relaxed">
                Consultația este primul pas pentru un tratament reușit, evaluând șansele de salvare a dintelui și stabilind un plan de tratament personalizat.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-blue-50 rounded-2xl shadow hover:shadow-lg transition flex flex-col">
            <img
              src={cabinet}
              alt="Retratamente endodontice"
              className="rounded-t-2xl h-40 sm:h-48 w-full object-cover"
            />
            <div className="p-6 flex flex-col flex-1">
              <h3 className="font-semibold text-lg sm:text-xl mb-2">Radiografie retroalveolara</h3>
              <p className="text-blue-700 font-bold mb-2 text-sm sm:text-base">de la 600 RON</p>
              <p className="text-gray-600 text-sm sm:text-base flex-1 leading-relaxed">
                Pentru un diagnostic corect, este necesară o radiografie retroalveolară, realizată în prima ședință dacă pacientul nu are una recentă. Aceasta oferă o imagine clară a dintelui și a rădăcinilor, esențială pentru identificarea infecțiilor, fracturilor sau altor probleme.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-blue-50 rounded-2xl shadow hover:shadow-lg transition flex flex-col">
            <img
              src={cabinet}
              alt="Microscopie dentară"
              className="rounded-t-2xl h-40 sm:h-48 w-full object-cover"
            />
            <div className="p-6 flex flex-col flex-1">
              <h3 className="font-semibold text-lg sm:text-xl mb-2">CBCT</h3>
              <p className="text-blue-700 font-bold mb-2 text-sm sm:text-base">de la 300 RON</p>
              <p className="text-gray-600 text-sm sm:text-base flex-1 leading-relaxed">
                În anumite cazuri, este necesară realizarea unei scanări CBCT (imagine 3D a dintelui), pentru a obține un diagnostic cât mai exact. Această investigație are și rolul de a optimiza tratamentul ulterior, astfel încât să fie mai scurt ca durată și mai eficient din punct de vedere al costurilor.
              </p>
            </div>
          </div>
        </div>
        <h3 className="text-center text-gray-600 text-sm sm:text-base max-w-4xl mx-auto px-2 sm:px-6 my-6 leading-relaxed">
          Tarifele variază, în general, între 800 și 1600 de lei per dinte, însă pot exista excepții, în funcție de gradul de complexitate al fiecărui caz. În urma consultației inițiale, veți primi o estimare detaliată și personalizată a costurilor aferente tratamentului.
        </h3>
      </section>
      

      {/* FAQ Section */}
      <section className="bg-gray-50 py-14 sm:py-16 px-4 sm:px-6 lg:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="flex justify-start">
            <button
              type="button"
              onClick={() => setShowFaq((prev) => !prev)}
              className="bg-blue-700 hover:bg-blue-800 text-white font-semibold text-sm sm:text-base inline-flex items-center gap-2 px-6 sm:px-8 py-3 rounded-full shadow transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-300"
              aria-expanded={showFaq}
            >
              Intrebari frecvente
              <span aria-hidden>{showFaq ? "−" : ">"}</span>
            </button>
          </div>
          {showFaq && (
            <div className="mt-10">
              <h2 className="text-2xl sm:text-3xl font-semibold text-blue-900 text-center mb-8">
                ALTE ÎNTREBĂRI FRECVENTE
              </h2>
              <div className="space-y-4">
                {faqItems.map((item, index) => {
                  const isOpen = activeFaq === index;
                  return (
                    <div
                      key={item.question}
                      className="bg-white rounded-2xl shadow-sm border border-blue-100">
                      <button
                        type="button"
                        onClick={() => toggleFaq(index)}
                        className="w-full flex items-center justify-between gap-4 text-left px-6 sm:px-8 py-5 sm:py-6"
                        aria-expanded={isOpen}
                      >
                        <span className="font-semibold text-sm sm:text-base uppercase text-blue-900">
                          {item.question}
                        </span>
                        <span className="text-blue-700 text-xl sm:text-2xl" aria-hidden>
                          {isOpen ? "−" : "+"}
                        </span>
                      </button>
                      {isOpen && (
                        <div className="px-6 sm:px-8 pb-6 sm:pb-8 space-y-4 text-gray-700 text-sm sm:text-base leading-relaxed">
                          {item.answer.map((paragraph, paragraphIndex) => (
                            <p key={paragraphIndex}>{paragraph}</p>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </section>

     
    </div>
  );
}
